import { defineStore } from 'pinia'
import {ref,reactive} from 'vue'
import axios from 'axios'
import { fix, subtract, divide, multiply, add, round } from 'mathjs'
import { closeModal, hideModal, openModal, centToDollar } from '../utilities/_helpers'
import { useUserStore } from './UserStore.js'
import { useLocalizationStore } from './LocalizationStore.js'
import { useRoute, useRouter } from 'vue-router'

export const useDisputeLetterStore = defineStore('DisputeLetterStore', {
    state: () => {
        const lob = 1, switchMail = 2;
        const firstClass = 1, certifiedMail = 2, certifiedReturnReceipt = 3;
        const autoSelect = 0, small = 1, medium = 2, large = 3, flat = 4, mediumFlat = 5;
        const blackAndWhite = 0, color = 1;
        const extraSheet = "extra_sheet", eCertified = "e_certified";
        return {
            letters : null,
            letterId : ref(0),
            letterContentPreview : ref(),
            letterBtnEdit : ref(),
            showSweetAlert : ref(false),
            creditorName : ref(),
            deleteTittle : ref(),
            deleteContent : ref(),
            toDeleteLetter : ref(false),
            deleteLetter : ref(false),
            deleteBulkLetter : ref(false),
            toDeleteBulkLetter : ref(false),
            datesent : ref([]),
            keyBulkDeleteBtn : ref(1),
            keyDeleteBtn : ref(1),
            statuses : ref({}),
            bureau_response : reactive({}),
            client_id : ref(),
            team_id : ref(),
            showCertifiedMailModel : ref(false),
            certifiedSelected : ref([]),
            certifiedMailSelectedById : ref([]),
            selectedMail:ref([]),
            extraServices: ref(1),
            colored:ref('no'),
            doubleSided:ref('yes'),
            collectionOfLettersAndPricing:ref([]),
            allpages:ref(0),
            certifiedPricing : reactive({
                total:0,
                BWFistclassLetter:0.715,
                BWLettersAdditionalPage:0.09,
                colorLetterfirstclass:0.755,
                colorLetterAdditionalPage:0.19,
                certifiedMail:5.40,
                CertifiedReturnReceipt:7.40,
            }),
            showLoader:false,
            totalLetterSelected:0,
            totalLetterLoaded: ref(0),
            config: {
                wrap: true,
                altFormat: 'F j, Y',
                altInput: true,
                dateFormat: 'Y-m-d',
            },
            faxNumber: reactive({}),
            mailables: reactive([]),
            letterTypes: {
                [lob]: {
                    [firstClass]: "First Class",
                    [certifiedMail]: "Certified Mail",
                    [certifiedReturnReceipt]: "Certified + Return Receipt"
                },
                [switchMail]: {
                    [firstClass]: "First Class",
                    [certifiedMail]: "Certified Mail"
                },
            },
            defaultMailer: ref(switchMail),
            lob: lob,
            switchMail: switchMail,
            firstClass: firstClass,
            certifiedMail: certifiedMail,
            certifiedReturnReceipt: certifiedReturnReceipt,
            autoSelect: autoSelect,
            small: small,
            medium: medium,
            large: large,
            flat: flat,
            mediumFlat: mediumFlat,
            blackAndWhite: blackAndWhite,
            color: color,
            extraSheet: extraSheet,
            eCertified: eCertified,
            envelop: {
                // [autoSelect]: "Autoselect",
                [small]: "Small",
                [medium]: "Medium",
                [large]: "Large",
                // [flat]: "Flat",
                // [mediumFlat]: "MediumFlat"
            },
            mails: {
                [switchMail]: {
                    pricing: { // https://www.switchmail.com/pricing/
                        [firstClass]: {
                            [blackAndWhite]: {
                                [small]: "1.7",
                                [medium]: "1.77",
                                [large]: "2.86",
                                [extraSheet]: "0.32",
                                [eCertified]: "0",
                            },
                            [color]: {
                                [small]: "2.62",
                                [medium]: "2.69",
                                [large]: "3.78",
                                [extraSheet]: "0.53",
                                [eCertified]: "0",
                            },
                        },
                        [certifiedMail]: {
                            [blackAndWhite]: {
                                [small]: "0",
                                [medium]: "0",
                                [large]: "0",
                                [extraSheet]: "0.32",
                                [eCertified]: "9",
                            },
                            [color]: {
                                [small]: "0",
                                [medium]: "0",
                                [large]: "0",
                                [extraSheet]: "0.53",
                                [eCertified]: "10",
                            },
                        }
                    },
                    sheets: {
                        [small]: {
                            size: "4",
                            message: "The total pages of this documents do not fit inside a Small envelope. Max page count is 8 double-sided and 4 pages for one-sided",
                        },
                        [medium]: {
                            size: "12",
                            message: "The total pages of this documents do not fit inside a Medium envelope. Max page count is 24 double-sided and 12 pages for one-sided",
                        },
                        [large]: {
                            size: "49",
                            message: "The total pages of this documents do not fit inside a Large envelope. Max page count is 98 double-sided and 49 pages for one-sided",
                        },
                    }
                }
            },
            modalID: 'send-mail-modal',
            sendLobMailerKey: ref(1),
            closeModal: closeModal,
            hideModal: hideModal,
            centToDollar: centToDollar,
            userStore: useUserStore(),
            localizationStore:  useLocalizationStore(),
            isMailSent: ref(false),
            mail_id: ref(null),
            display: ref(1), // 1 for list, 2 for view single item,
            route: useRoute(),
            router: useRouter(),
        }
    },
    actions: {
        async fetchLetters() {
            try {
                this.user = await axios.get(`${baseUrl}`)
                .then(function (response) {
                    return response.data.data.user;
                });
            } catch (error) {
            }
        },
        toggleSweetAlert(val){
            this.showSweetAlert = val;
            this.toDeleteLetter = false;
            this.deleteLetter = false;
            this.deleteBulkLetter = false;
            this.toDeleteBulkLetter = false;
        },
        resetCertifiedSelected(){
            this.certifiedSelected = [];
        },
        sumOfItems(array,){
            const sum = array.reduce((partialSum, a) => partialSum + a, 0);
            return sum;
        },
        getFirstPagePrice(letterType) {
            switch (letterType) {
                case '1':
                    return this.colored == 'yes' ? this.certifiedPricing.colorLetterfirstclass : this.certifiedPricing.BWFistclassLetter;
                case '2':
                    return this.certifiedPricing.certifiedMail;
                case '3':
                    return this.certifiedPricing.CertifiedReturnReceipt;
            }
        },
        getAdditionalPagesPrice(pages) {
            let price = this.colored == 'yes' ? this.certifiedPricing.colorLetterAdditionalPage : this.certifiedPricing.BWLettersAdditionalPage;
            return multiply(subtract(pages, 1), price);
        },
        removeLetter(id) {
            if (this.mailables.length == 1) {
                hideModal(`#${this.modalID}`);
            }
            _.remove(this.mailables, { id: id });
        },
        validate() {
            const $this = this;
            let status = true;
            if ($this.getTotal() > this.userStore.user.balance) {
                $this.sendLobMailerKey++;
                $this.isMailSent = false;
                toastr.error(this.localizationStore.translate('minimum.balance.error'), 'Error!');
                return false;
            }
            _.forEach($this.mailables, function(mail) {
                const sheet = $this.mails[$this.defaultMailer].sheets[mail.envelop_size];
                let numberOfPages = mail.number_of_pages;
                if ($this.doubleSided == 'yes') {
                    numberOfPages = round(divide(numberOfPages, 2));
                }
                if (numberOfPages > sheet.size) {
                    $this.sendLobMailerKey++;
                    $this.isMailSent = false;
                    toastr.error(sheet.message, 'Error!');
                    status = false;
                    return false;
                }
            });
            return status;
        },
        resetMailModal() {
            this.mailables.length = 0;
            this.colored = "no";
            this.doubleSided = "yes";
            this.extraServices = 1;
            this.totalLetterLoaded = 0;
        },
        async fetchCreditors(){
            const route = this.router.resolve(
                {
                    name: 'fetch-creditors'
                }
            );
            try {
                this.faxNumber = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {
            }
        }
    },
    getters: {
        getPrice: (state) => {
            return (letter) => {
                const serviceCharges = centToDollar(process.env.MIX_SWITCHMAIL_SERVICE_CHARGES);
                if (state.defaultMailer == state.lob) {
                    let pagePrice = state.colored == 'yes' ? state.certifiedPricing.colorLetterAdditionalPage : state.certifiedPricing.BWLettersAdditionalPage,
                    mailPrice = 0;
                    switch (letter.extra_service) {
                        case '1':
                            mailPrice = state.colored == 'yes' ? state.certifiedPricing.colorLetterfirstclass : state.certifiedPricing.BWFistclassLetter;
                            break;
                        case '2':
                            mailPrice = state.certifiedPricing.certifiedMail;
                            break;
                        case '3':
                            mailPrice = state.certifiedPricing.CertifiedReturnReceipt;
                            break;
                    }
                    return fix(add(multiply(subtract(letter.number_of_pages, 1), pagePrice), mailPrice, serviceCharges), 2);
                }
                else {
                    const pagesCount = state.doubleSided == 'yes' ? round(divide(subtract(letter.number_of_pages, 1), 2)) : subtract(letter.number_of_pages, 1);
                    const printType = state.colored == 'yes' ? state.color : state.blackAndWhite;
                    const envelopCost = state.mails[state.defaultMailer].pricing[letter.extra_service][printType][letter.envelop_size];
                    const extraSheetCost = state.mails[state.defaultMailer].pricing[letter.extra_service][printType][state.extraSheet];
                    const sheetsPrice = multiply(pagesCount, extraSheetCost);
                    const firstPagePrice = state.mails[state.defaultMailer].pricing[letter.extra_service][printType][state.eCertified];
                    return fix(add(envelopCost, sheetsPrice, firstPagePrice, serviceCharges),2);
                }
            }
        },
        getAdditionalPages: (state) => {
            return (letter = null) => {
                if (_.isNull(letter)) {
                    let totalPages = _.sumBy(state.mailables, 'number_of_pages');
                    const numberOfPages = subtract(totalPages, state.mailables.length);
                    return state.doubleSided == 'yes' ? round(divide(numberOfPages, 2)) : numberOfPages;;
                }
                const numberOfPages = subtract(letter.number_of_pages, 1);
                return state.doubleSided == 'yes' ? round(divide(numberOfPages, 2)) : numberOfPages;
            }
        },
        getTotal: (state) => {
            return () => {
                let total = 0;
                _.forEach(state.mailables, function(letter) {
                    total = add(total, state.getPrice(letter));
                });
                return fix(total, 2);
            }
        },
    },
})
